/* eslint-disable react-hooks/exhaustive-deps */
/*eslint-disable @typescript-eslint/restrict-plus-operands */
import {
    Dispatch,
    FC,
    SetStateAction,
    useContext,
    useEffect,
    useState,
} from "react";
import clsx from "clsx";
import { ScrollBar, Button } from "@ht/components";

import VirtualBackgroundIcon from "@ht/shared/fonts/deos-pis/virtual-background";
import VideoOffIcon from "@ht/shared/fonts/deos-pis/video-camera-off";
import VideoOnIcon from "@ht/shared/fonts/deos-pis/video-camera";
import MuteIcon from "@ht/shared/fonts/deos-pis/mic-mute";
import UnmuteIcon from "@ht/shared/fonts/deos-pis/mic";
import CloseIcon from "@ht/shared/fonts/deos-pis/close";
import NotTalkIcon from "@ht/shared/fonts/deos-pis/radio-none";
import ShareScreenIcon from "@ht/shared/fonts/deos-pis/monitor";
import HangupIcon from "@ht/shared/fonts/deos-pis/call-hangup";
import ChatIcon from "@ht/shared/fonts/deos-pis/chat";
import FullScreenIcon from "@ht/shared/fonts/deos-pis/fullscreen";
import ExitFullScreenIcon from "@ht/shared/fonts/deos-pis/exit-fullscreen";
import * as vcallActions from "../../../../app/videocall/videoSlice";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
    vCallIncomingMessageReceived,
    vCallSendMessage,
    vCallStateChanged,
} from "../../../../app/videocall/videoSlice";
import { setOverlay } from "../../../../app/layout/layoutStateSlice";

import { useDragging } from "../../../../hooks/useDragging";
import VideoCard from "../Cards/VideoCard";
import { useNavigate, useParams } from "react-router-dom";
import { SettingsContext, MediaSettingsContext } from "../../DMSMedia";
import ProfileBody from "../../../../pages/chat/components/ProfileBody";
import {
    ICustomerData,
    IIncomingRoom,
    IMessage,
} from "../../../../app/chat/types";
import MessageHeader from "../../../../pages/chat/components/MessageHeader";
import MessageBody from "../../../chat/MessageBody";
import MessageFooter from "../../../../pages/chat/components/MessageFooter";
import dayjs from "dayjs";
import { readMessage, activeChatRoom } from "../../../../app/chat/chatSlice";
import { useHttpRequest } from "../../../../hooks/useHttpRequest";
import moment from "moment";
import RightPanel from "../../../../pages/chat/components/RightPanel";
import { setOnCall } from "../../../../app/userState/userStateSlice";
import {
    IVCallIncomingMessage,
    IVCallState,
} from "../../../../app/videocall/types";
import { decrypt, encrypt } from "../../../../utils/encryption";
import { ConferenceContext } from "../..";
import LayoutPinned from "./LayoutPinned";
import LayoutTiled from "./LayoutTiled";

type LocalData = {
    streamId: string;
};
interface IProps {
    participants: any[];
    allParticipants: any[];
    myLocalData: LocalData | undefined;
    roomName: string;
    handleChangeRoomStatus(status: string): void;
}
const VideoCallControl: FC<IProps> = ({ participants, allParticipants, myLocalData, roomName, handleChangeRoomStatus }) => {
    const dispatch = useAppDispatch();

    const conference = useContext(ConferenceContext);

    const [pinRemoteVideo, setPinRemoteVideo] = useState(true);
    const [pinVideoId, setPinVideoId] = useState("");
    const [roomId, setRoomId] = useState("");
   
    const { user } = useAppSelector((state) => state.auth);
    const { vCallIncomingMessage, vCallState } = useAppSelector(
        (state) => state.vcall
    );

    const { incomingRoom, activeRoom, messages, scrollPosition } =
        useAppSelector((state) => state.chat);
    const { floatingLocation, overlay } = useAppSelector(
        (state) => state.layoutstate
    );

    const [duration, setDuration] = useState(
        vCallState.duration > 0 ? vCallState.duration : 0
    );
    const [intervalId, setIntervalId] = useState(0);
    const [joinedRoom] = useState(false);
    const callnotifWidth = 520;
    const locationX =
        floatingLocation.x === 0
            ? (screen.width - callnotifWidth) / 2
            : floatingLocation.x;
    const locationY =
        floatingLocation.y === 0 ? floatingLocation.y + 66 : floatingLocation.y;
    const [fullscreen, setFullscreen] = useState(false);
    const { ref, x, y, isDragging } = useDragging(
        locationX,
        locationY,
        520,
        20
    );

    const { chatId, customerid } = useParams();
    const [rightPanel, setRightPanel] = useState("profile");

    const navigate = useNavigate();
    const [opponent, setOpponent] = useState<IIncomingRoom>();
    const [chatList, setChatList] = useState<IMessage[]>();
    const [isScroll, setIsScroll] = useState(false);
    const [username, setUsername] = useState(vCallIncomingMessage.username);
    const { sendRequest } = useHttpRequest();
    const customerBaseUrl = String(process.env.REACT_APP_CUSTOMER_SERVICE);
    const routingServiceUrl = String(process.env.REACT_APP_CHAT_SERVICE);
    const [virtualBackgroundList, setVirtualBackgroundList] = useState<any>([]);
    const [waitingForEndMeeting, setWaitingForEndMeeting] = useState(false)
    const loadVB = async () => {
        const tenantId = user?.tenantId//idris ganti tenantid beneran
        const data = await sendRequest({
            baseUrl: routingServiceUrl,
            url: `/service-group/virtual_background_userless/${tenantId}`,
            method: "get",
        });
        return data;
    }

    const getVirtualBackground = () => {
        loadVB().then((res) => {
            console.log("vb res>", res)
            const { data } = res;

            let vbData: any = [];
            if (data && data?.length > 0) {
                data?.map((vb: any) => {
                    console.log("vb data:", vb)
                    vbData = [...vbData, {
                        ...vb,
                        imagePath: vb.image_path,
                        id: vb.id

                    }]
                })
                console.log("vb data refresh:", vbData)

            }
            setVirtualBackgroundList(vbData);
        }).catch((e) => console.log(e));



    }
    function toDataURL(url: string, callback: any) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }
    const [showVirtualBackground, setShowVirtualBackground] = useState(false)
    const toggleShowVirtualBackground = () => {
        setShowVirtualBackground(!showVirtualBackground)
    }

    const [customerData, setCustomerData] = useState<ICustomerData>({
        id: undefined,
        profile_picture: "",
        fullname: undefined,
        email: [""],
        dob: moment().unix(),
        gender: "male",
        phone_number: [""],
        facebook_ids: [""],
        religion: "",
        address: "",
        tenant_id: user?.tenantId,
        room_id: activeRoom?.roomId,
    });
    const resetIncomingCall = () => {
        dispatch(vCallIncomingMessageReceived({} as IVCallIncomingMessage));
        dispatch(vCallStateChanged({} as IVCallState));
    };
    const SendRequestEndMeeting = () => {

        const payload = JSON.stringify({
            requesttype: "RequestEndMeeting",
            roomId: conference?.roomName,
            tenantId: user?.tenantId,
            publishStreamId: conference?.publishStreamId

        });
        console.log("sending request end meeting", payload)
        dispatch(vcallActions.vCallSendMessage({ content: payload }));
    }
    const SendRequestStartMeeting = () => {

        const payload = JSON.stringify({
            requesttype: "RequestStartMeeting",
            roomId: conference?.roomName,
            tenantId: user?.tenantId,
            publishStreamId: conference?.publishStreamId

        });
        console.log("sending request start meeting", payload)
        dispatch(vcallActions.vCallSendMessage({ content: payload }));
    }
    const SendNotifyEndMeeting = () => {

        const payload = JSON.stringify({
            requesttype: "EndMeeting",
            roomId: conference?.roomName,
        });
        console.log("sending end meeting", payload)
        dispatch(vcallActions.vCallSendMessage({ content: payload }));
    }
    const RequestDeleteStreamId = () => {

        const payload = JSON.stringify({
            requesttype: "RequestDeleteStream",
            streamId: conference?.publishStreamId,
        });
        console.log("SendRequestDeleteStream", payload)
        dispatch(vcallActions.vCallSendMessage({ content: payload }));
    }
    useEffect(() => {
        if (messages && opponent) {
            const filteredMessages = messages.filter(
                (a) => a.roomId == opponent.roomId
            );
            const sortedMessages = filteredMessages.sort(
                (a, b) =>
                    new Date(
                        dayjs(a.messageTime).format("YYYY-MM-DD HH:mm:ss")
                    ).getTime() -
                    new Date(
                        dayjs(b.messageTime).format("YYYY-MM-DD HH:mm:ss")
                    ).getTime()
            );
            setChatList(sortedMessages);
        }
    }, [messages, opponent]);
    const changeRoom = () => {
        if (roomId) {
            const currentActiveRoom = incomingRoom.find(
                (z) => z.roomId === roomId
            );
            if (currentActiveRoom) {
                dispatch(activeChatRoom(currentActiveRoom));
            }

            if (scrollPosition == "bottom") setIsScroll((prev) => !prev);
            dispatch(
                readMessage({
                    sessionId: currentActiveRoom?.sessionId,
                    messageId: 0,
                })
            );
            setOpponent(incomingRoom.find((a) => a.roomId == roomId));
        }
    };
    useEffect(() => {
        if (incomingRoom.length > 0 && activeRoom !== undefined) {
            changeRoom();
        }
    }, [incomingRoom, activeRoom]);
    useEffect(() => {
        if (chatId) setRoomId(decrypt(chatId));
    }, [chatId]);
    useEffect(() => {
        if (scrollPosition == "bottom") setIsScroll((prev) => !prev);
    }, [scrollPosition, chatList]);
    let timer: number;

    const [gallerySize, setGallerySize] = useState({ "w": 100, "h": 100 });

    const handleGalleryResize = () => {

        const gallery = document.getElementById("meeting-gallery");

        if (gallery) {
            const screenWidth = gallery.getBoundingClientRect().width;
            const screenHeight = gallery.getBoundingClientRect().height;

            setGallerySize({ "w": screenWidth, "h": screenHeight });
        }
    }
    useEffect(() => {
        handleGalleryResize();
    }, [conference.videoTrackAssignments, conference.participantUpdated]);

    function getPinnedParticipant() {
        let firstPinnedParticipant: any;
        conference.allParticipants = conference.allParticipants || {};
        Object.keys(conference.allParticipants).forEach(streamId => {
            const participant = conference.allParticipants[streamId];
            if (typeof participant.isPinned !== 'undefined'
                && participant.isPinned === true
                && typeof firstPinnedParticipant === 'undefined') {

                firstPinnedParticipant = conference.allParticipants[streamId];
                return firstPinnedParticipant;
            }
        });
        return firstPinnedParticipant;
    }

    const firstPinnedParticipant = getPinnedParticipant();
    const pinnedParticipant = conference.videoTrackAssignments.find((e: { streamId: any; }) => e.streamId === firstPinnedParticipant?.streamId);

    useEffect(() => {
        //handleGalleryResize(false);
        window.conference = conference;
    }, [conference.videoTrackAssignments, conference.participantUpdated]);

    const handleOff = (e: any = undefined) => {
        if (e) e.stopPropagation();
        if (conference.isPlayOnly === null) {
            console.log('You need to allow camera and microphone permissions turning off your camera')
            return
        }
        if (conference.publishStreamId) {
            conference.checkAndTurnOffLocalCamera(conference.publishStreamId);
            conference.handleSendNotificationEvent(
                "CAM_TURNED_OFF",
                conference.publishStreamId
            );
        } else {
            // if local
            conference.checkAndTurnOffLocalCamera("localVideo");
        }

    };
    const handleOn = () => {
        //    if(e) e.stopPropagation();
        if (conference.publishStreamId) {
            conference.checkAndTurnOnLocalCamera(conference.publishStreamId);
            conference.handleSendNotificationEvent(
                "CAM_TURNED_ON",
                conference.publishStreamId
            );
        } else {
            // if local
            conference.checkAndTurnOnLocalCamera("localVideo");
        }
    };
    const toggleVirtualBackground = (imagepath: string) => {
        console.log("setting bg image:", imagepath)
        if (imagepath == "") {
            conference.handleBackgroundReplacement("none");
        } else {
            toDataURL(imagepath, function (dataUrl: any) {
                conference.setAndEnableVirtualBackgroundImage(conference.setAndEnableVirtualBackgroundImage(dataUrl));
            })
        }
    }
    const toggleScreenShare = () => {
        if (conference.isScreenShared) {
            conference.handleStopScreenShare();
        } else {
            conference.handleStartScreenShare();
            // send other that you are sharing screen.
        }
    }
    const toggleCamera = () => {
        if (!conference.isMyCamTurnedOff) {
            handleOff()
        }
        else {
            handleOn()
        }
        //if (msettings.camOffed) {
        //conference.turnOnLocalCamera()
        // }
        // else {
        //conference.turnOffLocalCamera()
        //}
        // msettings?.toggleSetCam({
        //     eventStreamId: "localVideo",
        //     isCameraOn: msettings.camOffed,
        // });
        // msettings.setCamOffed(!msettings.camOffed)
    }
    const handleMute = () => {
        // e.stopPropagation();
        if (conference.localVideo === null) {
            return
        }
        conference?.muteLocalMic();
    };

    const handleUnmute = () => {
        // e.stopPropagation();
        conference?.unmuteLocalMic();
    };

    const toggleMute = () => {
        if (!conference.isMyMicMuted)
            handleMute();
        else
            handleUnmute()
        //        msettings.setMicMuted(!msettings.micMuted)
    }

    const startTimer = () => {
        if (intervalId !== undefined) {
            timer = window.setInterval(() => {
                setDuration((dur) => dur + 1);
            }, 1000);
            setIntervalId(timer);
        }
    };
    const stopTimer = () => {
        window.clearInterval(intervalId);
    };
    const toHHMMSS = (dur: number) => {
        const hours = Math.floor(dur / 3600);
        const minutes = Math.floor((dur - hours * 3600) / 60);
        const seconds = dur - hours * 3600 - minutes * 60;
        let strhours = hours.toString();
        let strminutes = minutes.toString();
        let strseconds = seconds.toString();

        if (hours < 10) {
            strhours = "0" + hours.toString();
        }
        if (minutes < 10) {
            strminutes = "0" + minutes.toString();
        }
        if (seconds < 10) {
            strseconds = "0" + seconds.toString();
        }
        return strhours + ":" + strminutes + ":" + strseconds;
    };

    useEffect(() => {
        console.log("chatid changed opponent", activeRoom, incomingRoom);
        setOpponent(incomingRoom.find((a) => a.roomId === activeRoom.roomId));
    }, [activeRoom, incomingRoom]);



    const toggleStyle = (
        toggle: boolean,
        styleTrue: string,
        styleFalse: string
    ):
        | "warning"
        | "success"
        | "light"
        | "primary"
        | "secondary"
        | "danger"
        | "info"
        | "purple"
        | "facebook"
        | "twitter"
        | "royal"
        | undefined => {
        return (toggle ? styleTrue : styleFalse) as
            | "warning"
            | "success"
            | "light"
            | "primary"
            | "secondary"
            | "danger"
            | "info"
            | "purple"
            | "facebook"
            | "twitter"
            | "royal"
            | undefined;
    };

    const toggleFullscreen = () => {
        const cfullscreen = !fullscreen;
        setFullscreen(cfullscreen);
        //if (cfullscreen) navigate(`/messages/${encrypt(username)}`);
    };
    const hangupVideoCall = () => {
        console.log("end meeting... ", waitingForEndMeeting)
        if (!waitingForEndMeeting) {
            setWaitingForEndMeeting(true)
            SendRequestEndMeeting()
            RequestDeleteStreamId()
        } else {
            conference?.checkAndTurnOffLocalCamera("localVideo");
            stopTimer();
            handleOff();
            if (conference?.publishStreamId) conference.handleLeaveFromRoom();
            setWaitingForEndMeeting(false)
            setTimeout(() => {
                dispatch(setOnCall("ACW"));
                handleChangeRoomStatus("")
                resetIncomingCall();
                conference?.setStreamName("")
                conference?.setRoomName("")
                conference?.setPublishStreamId("")
            }, 1000);

        }

    };

    useEffect(() => {
        console.log("vcallincomingmessage>>>>XXXXX", vCallIncomingMessage, !joinedRoom, conference.roomName != "")
        if (
            vCallIncomingMessage.roomId != undefined && vCallIncomingMessage.streamId !== null &&
            !joinedRoom && vCallIncomingMessage.requesttype?.toLowerCase().includes("receivecall")
        ) {
            conference.joinRoom(conference.roomName, vCallIncomingMessage.streamId, "mcu");
            SendRequestStartMeeting()
            startTimer();
            if (vCallIncomingMessage.channel == "audio")
                toggleCamera();
        } else if (vCallIncomingMessage.requesttype?.toLowerCase()
            .includes("notifyendmeeting")) {
            SendNotifyEndMeeting()
            hangupVideoCall();
        }
    }
        , [vCallIncomingMessage]);

    const retrieveDataCustomer = async () => {
        const dt = await sendRequest({
            baseUrl: customerBaseUrl,
            url: `/customer-room/${activeRoom?.roomId}`,
            method: "get",
        });
        if (dt.data) {
            setCustomerData(dt.data as any);
        }
    };
    useEffect(() => {
        //requestStream();
        //handleOff();
        getVirtualBackground();
        setTimeout(() => {
            retrieveDataCustomer().catch((err) => {
                console.log(err);
            });
        }, 1000);
    }, []);
    const firstParticipant = conference?.videoTrackAssignments.find((x: any) => x.streamId.includes("participant"))
    return (
        <>
            <div
                onClick={() => dispatch(setOverlay(false))}
                onKeyDown={() => { }}
                role="none"
                className={clsx(
                    "fixed z-[19] w-screen h-screen flex justify-center items-center bg-gray-900 opacity-[0.2] duration-700",
                    { hidden: !overlay }
                )}
            ></div>
            <div
                style={{
                    left: x,
                    top: y,
                }}
                className={clsx(
                    { "bg-geyser": isDragging },
                    { "bg-white": !isDragging },
                    { "min-w-[30%] min-h-[30%] max-w-[65%] h-[50%] rounded-lg": !fullscreen },
                    { "w-[100%] h-[calc(100vh_-_54px)]": fullscreen },
                    { "!top-[54px] !left-0": fullscreen },
                    `absolute shadow-sm bg-white z-[21] overflow-hidden`
                )}
            >
                <div className="flex flex-col justify-between items-center h-[100%]">
                    <div className="absolute top-0 bg-white rounded-lg m-[8px] p-[8px] text-md self-start z-[99] flex flex-row">
                        <div className="hover:bg-geyser rounded-lg ">
                            <NotTalkIcon className="text-gray-200 w-[16px] h-[16px]" />
                        </div>
                        <div className="rounded-lg ml-[8px]">
                            <div className="flex flex-row gap-[8px] items-center leading-4">
                                {waitingForEndMeeting ?
                                    <span className="font-semibold text-black text-md">
                                        Meeting is ending.. removing participants
                                    </span>
                                    :
                                    <span className="font-semibold text-black text-md">
                                        {firstPinnedParticipant ? conference?.allParticipants[firstPinnedParticipant.streamId]?.name : firstParticipant ? conference?.allParticipants[firstParticipant?.streamId]?.name : ""}
                                    </span>
                                }
                                <span className="text-base text-grey-200 border-l-grey-200 border-l-[1px] pl-[8px]">
                                    {toHHMMSS(duration)}
                                </span>
                            </div>
                        </div>
                    </div>
                    <>
                        <div className="flex flex-row h-[100%] w-[100%]">
                            {conference.audioTracks.map((audioTrackAssignment: any, ix: number) => {
                                if (!audioTrackAssignment.isMine)
                                    return <VideoCard
                                        key={ix}
                                        trackAssignment={audioTrackAssignment}
                                        id={audioTrackAssignment.streamId}
                                        onHandlePin={() => { }}
                                        autoPlay
                                        name={""}
                                        style={{ display: "none" }}
                                    />
                            })}
                            <div
                                ref={ref}
                                id="meeting-gallery" className={clsx("draggable w-full h-full flex flex-row items-center")}
                            >
                                {
                                    <>
                                        {/* {LoadPinnedParticipant(
                                            pinVideoId,
                                            fullscreen,
                                            participants,
                                            setPinRemoteVideo,
                                            pinRemoteVideo,
                                            setPinVideoId,
                                            msettings
                                        )}
                                        {LoadUnpinnedParticipants(
                                            pinVideoId,
                                            fullscreen,
                                            participants,
                                            setPinRemoteVideo,
                                            setPinVideoId,
                                            msettings
                                        )}
                                        {LoadLocalVideo(
                                            pinVideoId,
                                            fullscreen,
                                            participants,
                                            setPinRemoteVideo,
                                            pinRemoteVideo,
                                            setPinVideoId
                                        )} */}
                                        {firstPinnedParticipant && <LayoutPinned
                                            pinnedParticipant={firstPinnedParticipant}
                                            width={gallerySize.w}
                                            height={gallerySize.h}
                                        />}
                                        {!firstPinnedParticipant && <LayoutTiled
                                            onLeftParticipant={() => {
                                                hangupVideoCall();
                                            }}
                                            pinnedParticipant={firstPinnedParticipant}
                                            width={gallerySize.w}
                                            height={gallerySize.h}
                                            isFullScreen={fullscreen}
                                        />}
                                        <div
                                            className={clsx(
                                                "draggable absolute p-[16px] bottom-[0px] flex flex-col items-center  w-[100%]",

                                            )}
                                        >
                                            <div
                                                className={clsx(
                                                    "rounded-md bg-white h-[52px] py-[8px] px-[16px] gap-[20px] flex flex-row justify-between "
                                                )}
                                            >
                                                <div className="flex flex-row-reverse justify-end gap-[12px] items-center">
                                                    <Button
                                                        shape="ellipse"
                                                        onClick={
                                                            hangupVideoCall
                                                        }
                                                        type="button"
                                                        variant="contained"
                                                        color="danger"
                                                        iconButton
                                                        className="w-[32px] h-[32px]"
                                                    >
                                                        <HangupIcon className="w-[20px] h-[20px] text-white" />
                                                    </Button>
                                                    <Button
                                                        shape="ellipse"
                                                        onClick={toggleMute}
                                                        type="button"
                                                        variant="contained"
                                                        color={toggleStyle(
                                                            conference.isMyMicMuted,
                                                            "primary",
                                                            "light"
                                                        )}
                                                        iconButton
                                                        className="w-[32px] h-[32px]"
                                                    >
                                                        {conference.isMyMicMuted ? (
                                                            <MuteIcon
                                                                className={clsx(
                                                                    "w-[20px] h-[20px] text-grey-200"
                                                                )}
                                                            />
                                                        ) : (
                                                            <UnmuteIcon
                                                                className={clsx(
                                                                    "w-[20px] h-[20px] text-grey-200"
                                                                )}
                                                            />
                                                        )}
                                                    </Button>
                                                    {vCallIncomingMessage.channel != "audio" &&
                                                        <>
                                                            <Button
                                                                shape="ellipse"
                                                                onClick={toggleCamera}
                                                                type="button"
                                                                variant="contained"
                                                                color={toggleStyle(
                                                                    !conference.isMyCamTurnedOff,
                                                                    "light",
                                                                    "primary"
                                                                )}
                                                                iconButton
                                                                className="w-[32px] h-[32px]"
                                                            >
                                                                {!conference.isMyCamTurnedOff ? (
                                                                    <VideoOnIcon className="w-[20px] h-[20px] text-grey-200" />
                                                                ) : (
                                                                    <VideoOffIcon className="w-[20px] h-[20px] text-grey-200" />
                                                                )}
                                                            </Button>
                                                            {/* <Button
                                                                shape="ellipse"
                                                                onClick={toggleScreenShare}
                                                                type="button"
                                                                variant="contained"
                                                                color={toggleStyle(
                                                                    conference?.isScreenShared,
                                                                    "primary",
                                                                    "light"
                                                                )}
                                                                iconButton
                                                                className="w-[32px] h-[32px]"
                                                            >
                                                                <ShareScreenIcon
                                                                    className={clsx(
                                                                        "w-[20px] h-[20px] text-grey-200"
                                                                    )}
                                                                />
                                                            </Button> */}
                                                        </>}

                                                    {!(vCallState.isOutboundRoom && vCallState.customerId == decrypt(customerid)) && !(!vCallState.isOutboundRoom && vCallState.roomId == decrypt(chatId)) && (
                                                        <>
                                                            <Button
                                                                shape="ellipse"
                                                                onClick={() => {
                                                                    if (vCallState.isOutboundRoom) {
                                                                        navigate(`/leads/`)
                                                                        setTimeout(() => {
                                                                            navigate(`/leads/${encrypt(vCallState.roomId)}`)
                                                                        }, 1000);
                                                                    } else {
                                                                        navigate(`/messages/`)
                                                                        setTimeout(() => {
                                                                            navigate(`/messages/${encrypt(vCallState.roomId)}`)
                                                                        }, 1000);
                                                                    }
                                                                }
                                                                }
                                                                type="button"
                                                                variant="contained"
                                                                color={toggleStyle(
                                                                    rightPanel ===
                                                                    "chat",
                                                                    "primary",
                                                                    "light"
                                                                )}
                                                                iconButton
                                                                className="w-[32px] h-[32px]"
                                                            >
                                                                <ChatIcon
                                                                    className={clsx(
                                                                        "w-[20px] h-[20px] text-grey-200"
                                                                    )}
                                                                />
                                                            </Button>
                                                        </>
                                                    )}
                                                    <Button
                                                        shape="ellipse"
                                                        onClick={
                                                            toggleFullscreen
                                                        }
                                                        type="button"
                                                        variant="contained"
                                                        color={toggleStyle(
                                                            conference?.isScreenShared,
                                                            "primary",
                                                            "light"
                                                        )}
                                                        iconButton
                                                        className="w-[32px] h-[32px]"
                                                    >
                                                        {fullscreen && (
                                                            <ExitFullScreenIcon
                                                                className="w-[20px] h-[20px] text-grey-200"
                                                                width={24}
                                                                height={24}
                                                            />
                                                        )}
                                                        {!fullscreen && (
                                                            <FullScreenIcon
                                                                className="w-[20px] h-[20px] text-grey-200"
                                                                width={24}
                                                                height={24}
                                                            />
                                                        )}
                                                    </Button>
                                                    {vCallIncomingMessage.channel != "audio" &&
                                                        <>
                                                            <Button shape="ellipse" type="button" variant="contained" color={!showVirtualBackground ? "light" : "primary"} onClick={toggleShowVirtualBackground} iconButton className="w-[32px] h-[32px]">
                                                                {!showVirtualBackground ?
                                                                    <VirtualBackgroundIcon className={clsx("w-[20px] h-[20px]", "text-primary")}></VirtualBackgroundIcon>
                                                                    : <VirtualBackgroundIcon className={clsx("w-[20px] h-[20px]", "text-white")}></VirtualBackgroundIcon>
                                                                }
                                                            </Button>
                                                            {showVirtualBackground && <Button className={clsx("bg-purple-50 border-0 px-1 py-0")} onClick={() => { toggleVirtualBackground(``) }}>
                                                                <CloseIcon className="w-[16px] h-[16px] text-purple"></CloseIcon>
                                                            </Button>
                                                            }
                                                            {showVirtualBackground && virtualBackgroundList.map((vb: any, index: number) => {

                                                                return <div className='flex flex-row' key={index} >
                                                                    <Button className={clsx("bg-purple-50 border-0 px-0 py-0")} onClick={() => { toggleVirtualBackground(`${routingServiceUrl?.replace(/\/$/, "")}/vb/${vb?.imagePath}`) }}>
                                                                        <img
                                                                            src={`${routingServiceUrl?.replace(/\/$/, "")}/vb/${vb?.imagePath}`}

                                                                            alt="user"
                                                                            className="w-[24px] h-[24px] object-cover"
                                                                        />
                                                                    </Button>
                                                                </div>
                                                            })}
                                                        </>

                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                            {/* {fullscreen && (
                                <div className="w-[25vw]">
                                    {opponent && rightPanel === "profile" && (
                                        <RightPanel
                                            title="Customer Contact"
                                            visible={true}
                                            hideOptions={true}
                                        >
                                            <ProfileBody
                                                opponent={opponent}
                                                customerData={customerData}
                                                onUpdatedCustomer={() => {
                                                    retrieveDataCustomer().catch(
                                                        (err) => {
                                                            console.log(err);
                                                        }
                                                    );
                                                }}
                                            />
                                        </RightPanel>
                                    )}
                                    {opponent && rightPanel === "chat" && (
                                        <div className={clsx("h-[100%]")}>
                                            <div className={clsx("h-[100%]")}>
                                                <MessageHeader
                                                    customerData={customerData}
                                                    name={
                                                        customerData.fullname ??
                                                        opponent.fullName
                                                    }
                                                    status={opponent.status}
                                                    hideOptions={true}
                                                />
                                                <ScrollBar
                                                    className="bg-gray-50"
                                                    initialView="bottom"
                                                    bottom="120px"
                                                    onScrollUp={() => { }}
                                                    isPositionChange={isScroll}
                                                >
                                                    <MessageBody
                                                        chats={chatList}
                                                    />
                                                </ScrollBar>
                                                <MessageFooter
                                                    roomId={opponent.roomId}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )} */}
                        </div>
                    </>
                </div>
            </div>
        </>
    );
};

export default VideoCallControl;
